/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedBreadcrumbs_buyPage = {
    readonly breadcrumbs: ReadonlyArray<{
        readonly path: string | null;
        readonly displayName: string | null;
    } | null> | null;
    readonly " $refType": "BuySharedBreadcrumbs_buyPage";
};
export type BuySharedBreadcrumbs_buyPage$data = BuySharedBreadcrumbs_buyPage;
export type BuySharedBreadcrumbs_buyPage$key = {
    readonly " $data"?: BuySharedBreadcrumbs_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedBreadcrumbs_buyPage">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedBreadcrumbs_buyPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseBreadcrumbs",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '109989b1786963f0a6ed35f51070ffd7';
export default node;
